/**
 * @param {*String} myemail
 * @return {*Boolean}
 */
export const emailVerification = (myemail) => {
  var emailReg = /^[A-Za-z\d]+([-_.][A-Za-z\d]+)*@([A-Za-z\d]+[-.])+[A-Za-z\d]{2,8}$/
  if (emailReg.test(myemail)) {
    return true
  } else {
    return false
  }
}

/**
 * 验证数字开头或 + 号，包括国际号码
 * @param {String} phone 
 * @returns {Boolean}
 */
export const phoneVerification = (phone) => {
  var reg = /^(?:[+\d].*\d|\d)$/
  if (reg.test(phone)) {
    return true
  } else {
    return false
  }
}

/**
 * 验证国内手机号码
 * @param {String} phone 
 * @returns {Boolean}
 */
export const phoneVerificationCN = (phone) => {
  var reg = /^[1][3,4,5,6,7,8,9][0-9]{9}$/
  if (reg.test(phone)) {
    return true
  } else {
    return false
  }
}
